export default __webpack_public_path__ + "static/media/pantalon-deportivo-mujer.6a7ec274.png";